import React from "react";
import {
  translationConstants,
  centerStatusConstants,
  centerAppliedForStatus,
  Directions,
  CenterStatusEnum,
  TableColumnStyle,
} from "../../../../constants";
import Tooltip from "@mui/material/Tooltip";
import { copyToClipboard } from "../../../../system";

const {
  PENDING_CENTER,
  PAYMENT_PENDING,
  PAYMENT_REJECTED,
  DISABLED,
  REJECTED,
  APPROVED,
  RESTRICTED,
} = centerStatusConstants;

export const getcolumns = (
  t,
  getRowData,
  cities,
  direction,
  isApprovalPage
) => [
  {
    id: "id",
    accessor: "id",
    name: t(translationConstants.RECORD_ID),
    cell: (row) => (
      <Tooltip
        title={<div>{t(translationConstants.COPY_TO_CLIPBOARD)}</div>}
        placement="top"
        arrow
      >
        <div
          className="truncate-text cursor-pointer"
          onClick={() => copyToClipboard(row.id)}
        >
          {row.id}
        </div>
      </Tooltip>
    ),
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: TableColumnStyle.COLUMN_WIDTH_120,
    maxWidth: TableColumnStyle.COLUMN_WIDTH_120,
  },
  {
    id: "name",
    reorder: true,
    sortable: true,
    sortDirection: null,
    accessor: "name",
    name: t(translationConstants.fullName),
    selector: (row) => row.name,
  },
  {
    id: "noOfSpots",
    accessor: "noOfSpots",
    name: t(translationConstants.NUM_OF_SPOTS),
    selector: (row) => row.noOfSpots,
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: "140px",
    cell: (row) => <div style={{ minWidth: "140px" }}>{row.noOfSpots}</div>,
  },
  {
    id: "contactEmail",
    accessor: "contactEmail",
    name: t(translationConstants.Email),
    selector: (row) => row.contactEmail,
    reorder: true,
    sortable: true,
    sortDirection: null,
  },
  {
    id: "cityId",
    accessor: "cityId",
    name: t(translationConstants.CITY),
    selector: (row) => row.cityId,
    reorder: true,
    sortable: true,
    sortDirection: null,
    cell: (row) => {
      const city = cities.find((city) => city.id === row.cityId);
      return city
        ? direction === Directions.rtl
          ? city.arabicName
          : city.name
        : "";
    },
  },
  {
    id: "noOfInstructors",
    accessor: "noOfInstructors",
    name: t(translationConstants.NUM_OF_INSTRUCTORS),
    selector: (row) => row.noOfInstructors,
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: "170px",
    cell: (row) => (
      <div style={{ minWidth: "170px" }}>{row.noOfInstructors}</div>
    ),
  },
  {
    id: "noOfStudents",
    accessor: "noOfStudents",
    name: t(translationConstants.NUM_OF_STUDENTS),
    selector: (row) => row.noOfStudents,
    reorder: true,
    sortable: true,
    sortDirection: null,
    minWidth: "160px",
    cell: (row) => <div style={{ minWidth: "160px" }}>{row.noOfStudents}</div>,
  },
  {
    id: `${isApprovalPage ? "appliedFor" : "centerStatus"}`,
    accessor: `${isApprovalPage ? "appliedFor" : "centerStatus"}`,
    name: isApprovalPage
      ? t(translationConstants.Applied_For)
      : t(translationConstants.STATUS),
    selector: (row) => row.appliedFor,
    reorder: true,
    sortable: true,
    sortDirection: null,
    cell: (row) => (
      <span className="capitalize-first">
        {isApprovalPage
          ? processString(row.appliedFor, t)
          : t(getStatusValue(row.centerStatus))}
      </span>
    ),
  },
  {
    id: "actions",
    name: t(translationConstants.Actions),
    cell: (row) => (
      <svg
        onClick={() => getRowData(row)}
        className="table-action-btn"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z"
          stroke="#48722D"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle
          cx="12"
          cy="12"
          r="3"
          stroke="#48722D"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
];

export const getCenterStatusAppliedForOptions = (t) => {
  return [
    {
      id: 2,
      value: centerAppliedForStatus.Center,
      label: centerAppliedForStatus.Center,
    },
    {
      id: 3,
      value: centerAppliedForStatus.Nafes,
      label: centerAppliedForStatus.Nafes,
    },
    {
      id: 4,
      value: centerAppliedForStatus.Spot,
      label: centerAppliedForStatus.Spot,
    },
  ];
};

export const getCenterStatusOptions = (t) => {
  return [
    {
      id: CenterStatusEnum.Approved,
      value: "approved",
      label: t(translationConstants.APPROVED),
    },
    {
      id: CenterStatusEnum.PaymentRejected,
      value: "paymentRejected",
      label: t(translationConstants.PAYMENT_REJECTED),
    },
    {
      id: CenterStatusEnum.PaymentPending,
      value: "paymentPending",
      label: t(translationConstants.PAYMENT_PENDING),
    },
    {
      id: CenterStatusEnum.Restricted,
      value: "restricted",
      label: t(translationConstants.RESTRICTED),
    },
    {
      id: CenterStatusEnum.Disabled,
      value: "disabled",
      label: t(translationConstants.DISABLED),
    },
  ];
};

export const getStatusValue = (id) => {
  switch (id) {
    case CenterStatusEnum.Rejected:
      return REJECTED;
    case CenterStatusEnum.Pending:
      return PENDING_CENTER;
    case CenterStatusEnum.Approved:
      return APPROVED;
    case CenterStatusEnum.PaymentRejected:
      return PAYMENT_REJECTED;
    case CenterStatusEnum.PaymentPending:
      return PAYMENT_PENDING;
    case CenterStatusEnum.Disabled:
      return DISABLED;
    case CenterStatusEnum.Restricted:
      return RESTRICTED;
    default:
      return null;
  }
};

export const getExportHeaders = (columns) =>
  columns
    .filter((x) => x.id !== "actions")
    .map((h) => ({ label: h.name, key: h.accessor }));

export const getDataToExport = (data, t, cities, direction) =>
  data?.map((x) => ({
    ...x,
    centerStatus: t(getStatusValue(x?.centerStatus)),
    cityId: (() => {
      const city = cities.find((city) => city.id === x.cityId);
      return city
        ? direction === Directions.rtl
          ? city.arabicName
          : city.name
        : "";
    })(),
  }));

export const getCenterSpotStatus = (id) => {
  switch (id) {
    case 0:
      return PAYMENT_PENDING;
    case 1:
      return REJECTED;
    case 2:
      return PENDING_CENTER;
    case 3:
      return APPROVED;
    case 4:
      return PAYMENT_REJECTED;
    default:
      return null;
  }
};

export const processString = (inputString, t) => {
  // Split the input string by commas
  const values = inputString?.split(", ");

  // Append "Pending" to each value
  const modifiedValues = values?.map((value) => `${value}`);

  // Join the modified values back together with commas
  const result = modifiedValues
    ?.map((value) => t(translationConstants[value]))
    .join(", ");

  return result;
};
